export default [
  {
    displayName: '项目首页',
    name: 'projecthome',
    path: '/projecthome',
    src: require('../assets/img/home.png'),
    activeSrc: require('../assets/img/activeHome.png')
  },
  {
    displayName: '政策法规',
    name: 'projectnews',
    path: '/projectnews',
    src: require('../assets/img/regulations.png'),
    activeSrc: require('../assets/img/avtiveRegulations.png')
  },
  {
    displayName: '公告公示',
    name: 'announcement',
    path: '/announcement',
    src: require('../assets/img/announcement.png'),
    activeSrc: require('../assets/img/activeAnnouncement.png')
  },
  {
    displayName: '补偿方案',
    name: 'program',
    path: '/program',
    src: require('../assets/img/compensation-plan.png'),
    activeSrc: require('../assets/img/compensation-plan-active.png')
  },
  {
    displayName: '在线选房',
    name: 'selection',
    path: '/selection',
    src: require('../assets/img/selection.png'),
    activeSrc: require('../assets/img/activeSelection.png')
  },
  {
    displayName: '在线看房',
    name: 'xian',
    path: '/xian',
    src: require('../assets/img/selection.png'),
    activeSrc: require('../assets/img/activeSelection.png')
  },
  {
    displayName: '个人查询',
    name: 'personal',
    path: '/personal',
    src: require('../assets/img/personal.png'),
    activeSrc: require('../assets/img/activePersonal.png')
  }
];



// WEBPACK FOOTER //
// ./src/layout/project-menus.js